import apiZelo from '../backAxiosVendaToken';

class ServicosAdicionais {
    async buscarServicosAdicionais(codigoCidadeIbge) {
        try {
            const servicosAdicionais = await apiZelo.get(
                `associados/servicos-adicionais/todos?cidade=${codigoCidadeIbge}&planos=1`
            );

            return servicosAdicionais.data;
        } catch (error) {
            console.log(error);
        }
    }

    async buscarServicosAdicionaisCadastrados(inscricao) {
        try {
            const servicosAdicionais = await apiZelo.get(
                `/associados/servicos-adicionais/vinculados/${inscricao}`
            );

            return servicosAdicionais.data;
        } catch (error) {
            console.log(error);
        }
    }

    async inserirServicosAdicionais(payload) {
        try {
            const { inscricao, idsServicos } = payload;

            const inserirServicos = await apiZelo.post(
                `/associados/servicos-adicionais/vincular/${inscricao}`,
                idsServicos
            );

            return inserirServicos.data;
        } catch (error) {
            console.log(error);
            throw new Error(error.Error);
        }
    }

    async deletarServicosAdicionais(payload) {
        try {
            const { inscricao, idsServicos } = payload;

            const deletarServicos = await apiZelo.delete(
                `/associados/servicos-adicionais/desvincular/${inscricao}`,
                {
                    data: idsServicos
                }
            );

            return deletarServicos.data;
        } catch (error) {
            console.log(error);
            throw new Error(error.Error);
        }
    }
}

export default new ServicosAdicionais();
